import { lazy } from '@disy/lib/promise-utils';

import { ajax } from 'cadenza/api-client/api';

export interface HelpTooltipCallback {
  (topicId: string): Promise<string>;
}

const getAvailableHelpTooltipTopicIdsLazy = lazy(() => ajax<string[]>('/help-tooltips'));

export function getTooltipText(topicId: string): Promise<string> {
  return getAvailableHelpTooltipTopicIdsLazy().then((availableTopicIds: string[]) => {
    if (availableTopicIds.includes(topicId)) {
      return ajax<string>('/help-tooltips/' + topicId);
    } else {
      throw new Error('The help tooltip text referenced by the topicId [' + topicId + '] was not found.');
    }
  });
}
